import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface RadiusZipPoint {
  zipCode: string;
}

interface RadiusZipResponse {
  inputZip?: string;
  radiusMiles?: number;
  zipCodes?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class RadiusZipService {
  private apiBaseUrl = 'https://prestigezipradius-akbhb3e9fkdgescp.eastus-01.azurewebsites.net/';

  constructor(private http: HttpClient) {}

  public getZipCodes(zipCode: string, radiusMiles: number): Observable<string[]> {
    const params = new HttpParams()
      .set('zip', zipCode)
      .set('radiusMiles', radiusMiles.toString());

    return this.http
      .get<RadiusZipResponse>(`${this.apiBaseUrl}/api/zips/nearby`, { params })
      .pipe(
        map((response: RadiusZipResponse) => {
          if (response.zipCodes) {
            return response.zipCodes;
          }

         

          return [];
        }),
      );
  }
}